<script>
export default {
  props: ["clr"]
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 8.88661C15 12.2924 12.4402 15.4769 9 16.2501C5.55975 15.4769 3 12.2924 3 8.88661V6.21136C3 5.60236 3.36825 5.05336 3.93225 4.82311L7.68225 3.28861C8.52675 2.94286 9.47325 2.94286 10.3177 3.28861L14.0677 4.82311C14.6317 5.05411 15 5.60236 15 6.21136V8.88661V8.88661Z"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.4375 8.09375L8.625 10.9062L6.9375 9.21875"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
